<template>
  <div class="_content"></div>
</template>
<script>
import config from '@/configs/config'

export default {
  mounted() {
    window._locateToData = this.options
    let src = '/static/locateline.html'
    if (location.host.indexOf('xiaokunkeji') > -1) {
      // src = 'https://www.xiaokunkeji.cn/user/vue/locateline.html'
      src = `${config.apis.XK_MAP}`
    }
    // else if (location.host === 'wxdev.tuhu.work') {
    //   src = 'https://wxdev.tuhu.work/vue/locateline.html'
    // }
    const iframe = $(`<iframe width="100%" height="100%" frameborder="0" src="${src}"></iframe>`)
    $(this.$el).append(iframe)
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// lib/pages/_locate/index.vue